/**
 * JobMonitoringPage - Background job monitoring dashboard
 *
 * Surfaces the JobMonitoringDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides visibility into async jobs, queue depth, processing rates, and failures.
 *
 * Route: /admin/job-monitoring
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconClockPlay } from '@tabler/icons-react';

import { JobMonitoringDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function JobMonitoringPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="orange">
            <IconClockPlay size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Job Monitoring</Title>
            <Text size="sm" c="dimmed">
              Background job status, queue depth, and processing metrics
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <JobMonitoringDashboard />
    </Container>
  );
}

export default JobMonitoringPage;
